import React, { useEffect, useState } from "react";
import { Panel, Label } from "./Panel";
import { useDispatch } from "react-redux"
import { ReactComponent as ExpandIcon } from "../../../../../assets/svg/solobuilder/expandlight.svg";
import { ReactComponent as ExpandDarkIcon } from "../../../../../assets/svg/solobuilder/expanddark.svg";
import { ReactComponent as SyncBtn } from "../../../../../assets/svg/solobuilder/SyncOne.svg";
import { onSetBorderVisibility, onSetFontStylesVisibility, onSetTextEditorVisibility, onsetClrPicContext, onsetDropShadowVisibility,onSetErrorFontStylesVisibility } from "../../../../../stateManager/store/common/action";
import { useSelector } from "react-redux";
import { GridLayout } from "./GridLayout";
import { getComponents,getValue } from "../helpers";
import { AppState } from "../../../../../stateManager/store";
import { flexContainers, gridContainers } from '../helpers/handleContainers'
import useSyncStyles  from '../helpers/useSyncStyles';
import { containers } from '../constants'
import {
  Border,
  BorderRadius,
  FontSize,
  Margin,
  MarginBottom,
  MarginLeft,
  MarginRight,
  MarginTop,
  Padding,
  PaddingBottom,
  PaddingLeft,
  PaddingRight,
  PaddingTop,
  BackgroundColor,
  Color,
  BorderColor,
  FontWeight,
  Visible,
  Horizontal,
  Vertical,
  Absolute,
  AbsoluteBottom,
  AbsoluteLeft,
  AbsoluteRight,
  AbsoluteTop,
  Fixed,
  GridCols,
  GridGap,
  RowSpan,
  Span,
  FlexAlign,
  FlexDistribute,
  FlexGrow,
  FlexShrink,
  FlexWrap,
  Height,
  Width,
  GridRows,
  FontFamily,
  OverflowX,
  OverflowY,
  ZIndex,
  FontFamilyV3,
  FlexDirection
} from "./layout-components";
import { addComputedStyles, copyStyles, pushFormActionStack, setFixedElementsUpdateV3, updateElement, updateElementOnUndoRedo } from "../../../../../stateManager/store/formCreation_v2/actions";
import { useToast } from "../../../../../helpers/commonFunction";
import { LineHeight } from "./layout-components/line-height";
import { myRedoStack, myUndoStack } from "../stack/Stack";
import update from "immutability-helper";
import {ApplyBackgroundImage, BackgroundImageMenu} from "./BackgroundImageMenu";
import {onSetBgdMenuVisibility} from "../../../../../stateManager/store/common/action";
import { WizardWidth } from "./layout-components/wizardWidth";
import SyncStyle from "../helpers/SyncStyle";
import { DateRangeColor } from "./layout-components/date-range-color";

const DEFAULT_BORDER_LABEL = "Border Width";
const DEFAULT_BORDER_RADIUS_LABEL = "Border Radius";
const DEFAULT_FONT_SIZE_LABEL = "Font Size";
const DEFAULT_FONT_FAMILY_LABEL = "Font Family";
const DEFAULT_MARGIN = "Margin";
const DEFAULT_PADDING = "Padding";
const DEFAULT_BACKGROUND_COLOR = "Background";
const DEFAULT_COLOR = "Color";
const DEFAULT_BORDER_COLOR = "Border Color";
const DEFAULT_DATE_RANGE_COLOR = "Date Range Color";
const DEFAULT_LINE_HEIGHT_LABEL = "Line Height";
const DEFAULT_FONT_WEIGHT = "Font Weight";
const DEFAULT_HORIZONTAL_ALIGN = "Horizontal";
const DEFAULT_VERTICAL_ALIGN = "Vertical";
const DEFAULT_POSITION_ABSOLUTE = "Absolute";
const DEFAULT_POSITION_FIXED = "Fixed";
const DEFAULT_GRID_GAP = "Gap";
const DEFAULT_FLEX_GROW = "Grow";
const DEFAULT_FLEX_SHRINK = "Shrink";
const DEFAULT_WIDTH = "Width";
const DEFAULT_ZINDEX_LABEL = "ZIndex";
const DEFAULT_MARGIN_PATH: string = "properties.styles.$deviceType.margin";
const DEFAULT_MARGIN_TOP = "properties.styles.$deviceType.marginTop";
const DEFAULT_MARGIN_RIGHT = "properties.styles.$deviceType.marginRight";
const DEFAULT_MARGIN_BOTTOM = "properties.styles.$deviceType.marginBottom";
const DEFAULT_MARGIN_LEFT = "properties.styles.$deviceType.marginLeft";
const DEFAULT_PADDING_PATH: string = "properties.styles.$deviceType.padding";
const DEFAULT_PADDING_TOP = "properties.styles.$deviceType.paddingTop";
const DEFAULT_PADDING_RIGHT = "properties.styles.$deviceType.paddingRight";
const DEFAULT_PADDING_BOTTOM = "properties.styles.$deviceType.paddingBottom";
const DEFAULT_PADDING_LEFT = "properties.styles.$deviceType.paddingLeft";


const padding_excluded_types = ["Slider", "Toggle"];

export const Layout = (props: any) => {
  const [isExpandMargin, setExpandMargin] = useState<boolean>(false);
  const [isExpandPadding, setExpandPadding] = useState<boolean>(false);
  const dispatch = useDispatch();
  const isGridSelected = useSelector((state: any) => {
    return state.formJson.isGridSelected
  })
  const { selectedElementId, deviceType, wrapperComputedStyles, computedStyles, isCoreV3, fixedArrayV3, gridStyles, canvasConfig } = useSelector((state: AppState) => state.formJson);
  const { backgroundMenuVisibility } = useSelector((state: AppState) => state.common);
  const { components } = getComponents()
  const component = components[selectedElementId];
  const parentComponent = component && component.parentId && components[component.parentId]
  const isParentGrid = (parentComponent && parentComponent.type !== "ExpansionPanel" && gridContainers.includes(parentComponent.type)) || (gridStyles[deviceType]?.layout === "Grid");
  const { ErrorToast } = useToast();
  const { syncStyles } = useSyncStyles();
  //Convert kebab case to camelcase for computedStyles;
  function kebabToCamel(kebab: any) {
    return kebab.replace(/-([a-z])/g, (match: any, letter: any) =>
      letter.toUpperCase()
    );
  }
  //To Get Computed styles
  useEffect(() => {
    setTimeout(() => {
      if (components[selectedElementId]) {
        const { id, type } = components[selectedElementId];
        let childElement: HTMLElement | null;
        if (type === "Row") {
          childElement = document.getElementById(`Row-${id}`)
        } else {
          childElement = document.getElementById(`${type}-${id}`); // for datepicker and date-input add __computed
        }
        if (childElement) {
          const local_computedStyles = window.getComputedStyle(childElement);
          const camelCaseStyles: any = {};
          for (let i = 0; i < local_computedStyles.length; i++) {
            const prop = local_computedStyles[i];
            const value = local_computedStyles.getPropertyValue(prop);
            const camelProp = kebabToCamel(prop);
            camelCaseStyles[camelProp] = value;
          }
        }
      }
    }, 0);
    setExpandMargin(false);
    setExpandPadding(false);
  }, [selectedElementId, deviceType]);

  const styles =
    component?.properties?.styles && component?.properties?.styles[deviceType];
  const marginValues = [
    styles?.marginTop || parseInt(computedStyles.marginTop, 10),
    styles?.marginRight || parseInt(computedStyles.marginRight, 10),
    styles?.marginBottom || parseInt(computedStyles.marginBottom, 10),
    styles?.marginLeft || parseInt(computedStyles.marginLeft, 10),
  ];
  const isAnyMarginGreaterThanZero = marginValues.some((value) => value > 0 || value < 0);

  const paddingValues = [
    styles?.paddingTop || parseInt(computedStyles.paddingTop, 10),
    styles?.paddingRight || parseInt(computedStyles.paddingRight, 10),
    styles?.paddingBottom || parseInt(computedStyles.paddingBottom, 10),
    styles?.paddingLeft || parseInt(computedStyles.paddingLeft, 10),
  ];
  const isAnyPaddingGreaterThanZero = paddingValues.some((value) => value > 0 || value < 0);

  useEffect(() => {
    if (isCoreV3) {
      setExpandMargin(isAnyMarginGreaterThanZero);
      setExpandPadding(isAnyPaddingGreaterThanZero);
    }
  }, []);

  if (isGridSelected) {
    return <GridLayout isCheckedIn={props.isCheckedIn} />;
  }

  if (!component?.id) {
    return null;
  }
  let gridCols, gridRows, visible, flexWrap, flexDirection, flexDistribute, flexAlign, flexGrow, flexShrink, gap, rowSpan, span, margin, marginTop, marginRight, marginBottom, marginLeft, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, fixed: boolean | undefined, absolute, top, right, bottom, left, alignX, alignY, width, wizardWidth, height, fontWeight, color, backgroundColor, fontSize, fontFamily, border, borderRadius, borderColor, dateRangeColor, overflowX, overflowY, zIndex, lineHeight;

  if (!isCoreV3) {
    const styles = component.properties.styles && component.properties.styles[deviceType];
    gridCols = styles?.gridCols;
    gridRows = styles?.gridRows;
    visible = styles?.visible;
    flexWrap = styles?.flexWrap;
    flexDistribute = styles?.flexDistribute;
    flexDirection = styles?.flexDirection;
    flexAlign = styles?.flexAlign;
    flexGrow = styles?.flexGrow;
    flexShrink = styles?.flexShrink;
    gap = styles?.gap;
    rowSpan = styles?.rowSpan || 1;
    span = styles?.span;
    margin = styles?.margin || 0;
    marginTop = styles?.marginTop;
    marginRight = styles?.marginRight;
    marginBottom = styles?.marginBottom;
    marginLeft = styles?.marginLeft;
    padding = styles?.padding || 12;
    paddingTop = styles?.paddingTop;
    paddingRight = styles?.paddingRight;
    paddingBottom = styles?.paddingBottom;
    paddingLeft = styles?.paddingLeft;
    fixed = styles?.fixed;
    absolute = styles?.absolute;
    top = styles?.top;
    right = styles?.right;
    bottom = styles?.bottom;
    left = styles?.left;
    alignX = styles?.alignX;
    alignY = styles?.alignY;
    width = styles?.width;
    height = styles?.height;

    fontWeight = component.properties.styles?.common.fontWeight || 400;
    color = component.properties.styles?.common.color;
    backgroundColor = component.properties.styles?.common.backgroundColor;
    fontSize = component.properties.styles?.common.fontSize || 16;
    fontFamily = component.properties.styles?.common.fontFamily || 'inherit';
    border = component.properties.styles?.common.border || 0;
    borderRadius = component.properties.styles?.common.borderRadius;
    borderColor = component.properties.styles?.common.borderColor;
    dateRangeColor = component.properties.styles?.common.dateRangeColor;
  } else {
    const styles = component.properties.styles && component.properties.styles[deviceType];
    gridCols = styles?.gridCols;
    gridRows = styles?.gridRows;
    visible = styles?.visible;
    flexWrap = styles?.flexWrap;
    flexDistribute = styles?.flexDistribute;
    flexDirection = styles?.flexDirection;
    flexAlign = styles?.flexAlign;
    flexGrow = styles?.flexGrow;
    flexShrink = styles?.flexShrink;
    gap = styles?.gap;
    rowSpan = styles?.rowSpan;
    span = styles?.span;
    margin = styles?.margin || parseInt(computedStyles.margin, 10);
    marginTop = styles?.marginTop || parseInt(computedStyles.marginTop, 10);
    marginRight = styles?.marginRight || parseInt(computedStyles.marginRight, 10);
    marginBottom = styles?.marginBottom || parseInt(computedStyles.marginBottom, 10);
    marginLeft = styles?.marginLeft || parseInt(computedStyles.marginLeft, 10);
    padding = styles?.padding || parseInt(computedStyles.padding, 10);
    paddingTop = styles?.paddingTop || parseInt(computedStyles.paddingTop, 10);
    paddingRight = styles?.paddingRight || parseInt(computedStyles.paddingRight, 10);
    paddingBottom = styles?.paddingBottom || parseInt(computedStyles.paddingBottom, 10);
    paddingLeft = styles?.paddingLeft || parseInt(computedStyles.paddingLeft, 10);
    fixed = styles?.fixed;
    absolute = styles?.absolute || wrapperComputedStyles.position === "absolute";
    top = styles?.top;
    right = styles?.right;
    bottom = styles?.bottom;
    left = styles?.left;
    alignX = styles?.alignX;
    alignY = styles?.alignY;
    width = styles?.width || parseInt(wrapperComputedStyles.width, 10);
    wizardWidth =  styles?.wizardWidth || "30"
    height = styles?.height || parseInt(wrapperComputedStyles.height, 10);
    overflowX = styles?.overflowX || "hidden";
    overflowY = styles?.overflowY || "hidden";
    zIndex = styles?.zIndex;
    lineHeight = component?.properties?.styles[deviceType]?.lineHeight ? component.properties.styles && component?.properties?.styles[deviceType]?.lineHeight : component?.properties?.styles?.common?.lineHeight;
    fontWeight = component?.properties?.styles[deviceType].fontWeight  ? component?.properties?.styles[deviceType]?.fontWeight : component?.properties?.styles?.common?.fontWeight;
    color = component?.properties?.styles[deviceType]?.color ? component.properties.styles && component?.properties?.styles[deviceType]?.color : component?.properties?.styles?.common?.color;
    backgroundColor = component?.properties?.styles[deviceType]?.backgroundColor
      ? component.properties.styles && component?.properties?.styles[deviceType]?.backgroundColor : component?.properties?.styles?.common?.backgroundColor;
    fontSize = component?.properties?.styles[deviceType]?.fontSize
      ? component.properties.styles && component?.properties?.styles[deviceType]?.fontSize : component?.properties?.styles?.common?.fontSize;
    fontFamily = component?.properties?.styles[deviceType]?.fontFamily ? component.properties.styles && component?.properties?.styles[deviceType]?.fontFamily : component?.properties?.styles?.common?.fontFamily;
    border = component?.properties?.styles[deviceType]?.border ? component.properties.styles && component?.properties?.styles[deviceType]?.border : component?.properties?.styles?.common?.border;
    borderRadius = component?.properties?.styles[deviceType]?.borderRadius ? component.properties.styles && component?.properties?.styles[deviceType]?.borderRadius : component?.properties?.styles?.common?.borderRadius;
    borderColor = component?.properties?.styles[deviceType]?.borderColor ? component.properties.styles && component?.properties?.styles[deviceType]?.borderColor : component?.properties?.styles?.common?.borderColor;
    dateRangeColor = component?.properties?.styles[deviceType]?.dateRangeColor ? component.properties.styles && component?.properties?.styles[deviceType]?.dateRangeColor : component?.properties?.styles?.common?.dateRangeColor;
  }

  const toggleExpandMargin = () => {
    setExpandMargin((prevValue) => !prevValue);
    const marginBooleanVal = !isExpandMargin;
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_MARGIN_PATH, value: margin, }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_MARGIN_TOP, value: !marginBooleanVal ? margin : margin || marginTop, }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_MARGIN_RIGHT, value: !marginBooleanVal ? margin : margin || marginRight }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_MARGIN_BOTTOM, value: !marginBooleanVal ? margin : margin || marginBottom }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_MARGIN_LEFT, value: !marginBooleanVal ? margin : margin || marginLeft }))  
  };

  const toggleExpandPadding = () => {
    setExpandPadding((prevValue) => !prevValue);
    const paddingBooleanVal = !isExpandPadding;
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_PADDING_PATH, value: padding, }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_PADDING_TOP, value: paddingBooleanVal ? padding ? padding : paddingTop : "" }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_PADDING_RIGHT, value: paddingBooleanVal ? padding ? padding : paddingRight : "" }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_PADDING_BOTTOM, value: paddingBooleanVal ? padding ? padding : paddingBottom : "" }))
    dispatch(updateElement({ id: selectedElementId, path: DEFAULT_PADDING_LEFT, value: paddingBooleanVal ? padding ? padding : paddingLeft : "" }))
  };

  const handleSyncSelectedElementStyle = (changeTo: string) => {
    if (fixed) {
      const targetDeviceTypes = getTargetDeviceTypes(deviceType);
      if (
        targetDeviceTypes.some((targetDeviceType) => fixedArrayV3[targetDeviceType].length > 0)) {
        ErrorToast("Target device types already have fixed elements. Cannot sync styles.");
        return;
      }
    }
    const componentIdsToUpdate = [selectedElementId];
    syncStyles({
      componentIdsToUpdate,
      deviceType,
      changeTo,
      syncTo: "COMPONENT",
    });
    let updatedFixedArray = fixedArrayV3;
    if (fixed === true) {
      const targetDeviceTypes = getTargetDeviceTypes(deviceType);
      targetDeviceTypes.forEach((targetDeviceType: any) => {
        const existingFixedArray = fixedArrayV3[targetDeviceType] || [];
        const updatedFixedArrayForTarget = [
          selectedElementId,
          ...existingFixedArray,
        ];
        updatedFixedArray = {
          ...updatedFixedArray,
          [targetDeviceType]: updatedFixedArrayForTarget,
        };
      });
      dispatch(setFixedElementsUpdateV3(updatedFixedArray));
    } else {
      const targetDeviceTypes = getTargetDeviceTypes(deviceType);
      targetDeviceTypes.forEach((targetDeviceType: any) => {
        updatedFixedArray[targetDeviceType] = updatedFixedArray[
          targetDeviceType
        ].filter((id: any) => id !== selectedElementId);
      });
      dispatch(setFixedElementsUpdateV3(updatedFixedArray));
    }
  };

  const getTargetDeviceTypes = (currentDeviceType: string): string[] => {
    if (currentDeviceType === "Sm") {
      return ["Md", "Lg"];
    } else if (currentDeviceType === "Md") {
      return ["Sm", "Lg"];
    } else if (currentDeviceType === "Lg") {
      return ["Sm", "Md"];
    } else {
      return [];
    }
  };

  const barchartres = component.type === "BarChart"
  const componentTypeForSnack = component.type === "SnackBar"
  const FontFamilyRestrictedTypes: string[] = ["ImageViewer"];
  const FontWeightRestrictedTypes: string[] = ["ImageViewer"];
  const ColorRestrictedTypes: string[] = ["ImageViewer"];
  const dateRangeColorType: string[] = ["DateRangePicker"];
  const borderWidthRestrictedTypes: string[] = ["DateRangePicker"];
  const borderRadiusRestrictedTypes: string[] = ["DateRangePicker"];
  const borderColorRestrictedTypes: string[] = ["DateRangePicker"];
  const heightRestrictedTypes: string[] = ["Select"];
  const shouldHidePropsForCustomSnack = componentTypeForSnack && component.properties.config.snackType !== "Custom";
  
  const componentTypes = ["RichtextEditor", "Slider", "Toggle"];
  const DEFAULT_BORDER_RADIUS = {
    selected: function () {
      return component?.type === "Textarea"
        ? 6
        : component?.type === "Input"
        ? 6
        : component?.type === "Button"
        ? 24
        : component?.type === "IconButton"
        ? 24
        : component?.type === "ExpansionPanel"
        ? 8
        : component?.type === "oAuth"
        ? 24
        : 0;
    },
  };
  const DEFAULT_BACKGROUNDCOLOR = {
    selected: function () {
      return component?.type === "oAuth"
        ? "#004B8D"
        : component?.type === "FAB" && "#6200EE";
    },
  };

  return (
    <>
      {isCoreV3 && component?.type !== "FormWizard" && (
        <>
          <SyncStyle
            syncTo= "COMPONENT"
            deviceType = {deviceType}
            handleSync = {handleSyncSelectedElementStyle}
          />
          <hr style={{ width: '100%', margin: '10px auto' }} />
        </>
      )}
      <form>
        {(component.type === "CustomModal" && isCoreV3 === false) || (gridContainers.includes(component.type) && component.type !== "CustomModal") ? (
          !componentTypeForSnack && <GridCols defaultValue={gridCols} isCheckedIn={props.isCheckedIn} />
        ) : null}
        {(component.type === "CustomModal" && isCoreV3 === false) || (gridContainers.includes(component.type) && component.type !== "CustomModal") ? (
         !componentTypeForSnack && <GridRows defaultValue={gridRows} isCheckedIn={props.isCheckedIn} />
        ) : null}
        {component.type === "Container" && !componentTypeForSnack && (
          <>
            <FlexDirection
              defaultValue={flexDirection}
              isCheckedIn={props.isCheckedIn}
            />
          </>
        )}
        {(component.type === "Row" || component.type === "Column" || component.type === "FlatList" || component.type === "Container" || (component.type === "CustomModal" && isCoreV3 === true)) && (
          !componentTypeForSnack &&
          <>
            <FlexDistribute
              defaultValue={flexDistribute}
              isCheckedIn={props.isCheckedIn}
            />
            <FlexAlign defaultValue={flexAlign} isCheckedIn={props.isCheckedIn} />
            <FlexWrap defaultValue={flexWrap} isCheckedIn={props.isCheckedIn} />
          </>
        )}
        {(component.type === "FlatList") &&
          <FlexDirection
            defaultValue={flexDirection}
            isCheckedIn={props.isCheckedIn}
          />
        }
        {(component.type !== "FlatList") &&
          <>
            {isParentGrid ? (
              !componentTypeForSnack &&
              <>
                <Span defaultValue={span} isCheckedIn={props.isCheckedIn} />
                <RowSpan defaultValue={rowSpan} isCheckedIn={props.isCheckedIn} />
              </>
            ) : (
              <>
                {!barchartres && !componentTypeForSnack &&
                  <FlexGrow
                    label={DEFAULT_FLEX_GROW}
                    defaultValue={flexGrow}
                    isCheckedIn={props.isCheckedIn}
                  />}
                {!barchartres &&  !componentTypeForSnack &&
                  <FlexShrink
                    label={DEFAULT_FLEX_SHRINK}
                    defaultValue={flexShrink}
                    isCheckedIn={props.isCheckedIn}
                  />}
              </>
            )}
          </>
        }

        {containers.includes(component.type) && !componentTypeForSnack && component.type !== 'FormWizard' && (
          <GridGap
            label={DEFAULT_GRID_GAP}
            defaultValue={gap}
            isCheckedIn={props.isCheckedIn}
          />
        )}

        {!componentTypeForSnack && (
          <Visible defaultValue={visible} isCheckedIn={props.isCheckedIn} />
        )}

        {!componentTypeForSnack && (
          <div className="panel-div">
            <Margin
              label={DEFAULT_MARGIN}
              defaultValue={margin}
              isCheckedIn={props.isCheckedIn}
              isExpandMargin={isExpandMargin}
            />
            <div onClick={toggleExpandMargin} data-test-id={`expand_margin-${isExpandMargin}`}>
              {isExpandMargin ? (
                <ExpandDarkIcon
                  style={{ width: 15, height: 15, marginLeft: "2px" }}
                  className=" items-center cursor-pointer"
                />
              ) : (
                <ExpandIcon
                  style={{ width: 15, height: 15, marginLeft: "2px" }}
                  className=" items-center cursor-pointer"
                />
              )}
            </div>
          </div>
        )}

        {isExpandMargin && !componentTypeForSnack && (
          <div className="flex justify-end" data-test-id="margin_TRBL_values" style={{ marginTop: "10px", gap: "4px" }} >
            <MarginTop
              defaultValue={marginTop}
              isCheckedIn={props.isCheckedIn}
            />
            <MarginRight
              defaultValue={marginRight}
              isCheckedIn={props.isCheckedIn}
            />
            <MarginBottom
              defaultValue={marginBottom}
              isCheckedIn={props.isCheckedIn}
            />
            <MarginLeft
              defaultValue={marginLeft}
              isCheckedIn={props.isCheckedIn}
            />
          </div>
        )}

        {( !isCoreV3 || !padding_excluded_types.includes(component.type)) && !componentTypeForSnack &&
        <>
        <div className="panel-div">
          <Padding
            label={DEFAULT_PADDING}
            defaultValue={padding}
            isCheckedIn={props.isCheckedIn}
            isExpandPadding={isExpandPadding}
          />
          <div onClick={toggleExpandPadding} data-test-id={`expand_padding-${isExpandPadding}`}>
            {isExpandPadding ? (
              <ExpandDarkIcon style={{ marginLeft: "2px", width: 15, height: 15 }} className="items-center cursor-pointer" />
            ) : (
              <ExpandIcon style={{ marginLeft: "2px", width: 15, height: 15 }} className=" items-center cursor-pointer" />
            )}
          </div>
        </div>
        {isExpandPadding && !componentTypeForSnack &&(
          <div className="flex justify-end" data-test-id="padding_TRBL_values" style={{ marginTop: "10px", gap: "4px" }}>
            <PaddingTop defaultValue={paddingTop} />
            <PaddingRight defaultValue={paddingRight} />
            <PaddingBottom defaultValue={paddingBottom} />
            <PaddingLeft defaultValue={paddingLeft} />
          </div>
        )}
        </>}
        {
          isParentGrid && (
            <>
              <Horizontal
                label={DEFAULT_HORIZONTAL_ALIGN}
                defaultValue={alignX}
                isCheckedIn={props.isCheckedIn}
              />
              <Vertical
                label={DEFAULT_VERTICAL_ALIGN}
                defaultValue={alignY}
                isCheckedIn={props.isCheckedIn}
              />
            </>
          )
        }
        {(flexContainers.includes(component.type) || gridContainers.includes(component.type) || component.type === "Text" || component.type === "Container") ? (
          <>
          <hr style={{ width: "100%", margin: "10px 0px" }} />
          <div style={{ color: "#282B31", fontSize: "11px", fontWeight: 700, height: 14 }}>Overflow</div>
            <OverflowX
              isCheckedIn={props.isCheckedIn}
              defaultValue={overflowX}
            />
            <OverflowY
              isCheckedIn={props.isCheckedIn}
              defaultValue={overflowY}
            />
          <hr style={{ width: "100%", margin: "10px auto" }} />
          </>
        ) : null}
        <>
          <Width
            label={DEFAULT_WIDTH}
            defaultValue={width}
            isCheckedIn={props.isCheckedIn}
          />
          {!heightRestrictedTypes.includes(component.type) &&
          <Height defaultValue={height} isCheckedIn={props.isCheckedIn} />
          }
        </>
        {!componentTypeForSnack && (
          <Absolute
            label={DEFAULT_POSITION_ABSOLUTE}
            defaultValue={absolute}
            isCheckedIn={props.isCheckedIn}
          />
        )}
        {!componentTypeForSnack && (
          <Fixed
            label={DEFAULT_POSITION_FIXED}
            defaultValue={fixed}
            isCheckedIn={props.isCheckedIn}
          />
        )}
        {absolute && (
          <div className="flex justify-end" data-test-id="absolute_TRBL_values" style={{marginTop: 10,gap: "4px"}}>
            <AbsoluteTop defaultValue={top} isCheckedIn={props.isCheckedIn} />
            <AbsoluteRight
              defaultValue={right}
              isCheckedIn={props.isCheckedIn}
            />
            <AbsoluteBottom
              defaultValue={bottom}
              isCheckedIn={props.isCheckedIn}
            />
            <AbsoluteLeft defaultValue={left} isCheckedIn={props.isCheckedIn} />
          </div>
        )}
        {
          (!componentTypes.includes(component?.type)) && (component.type !== "Select" && component.type !== "FormWizard") && component.type !== "RadioButton" && !borderWidthRestrictedTypes.includes(component?.type) &&
        <Border
        label={DEFAULT_BORDER_LABEL}
        defaultValue={border}
        isCheckedIn={props.isCheckedIn}
        />
        }
        {
          (!componentTypes.includes(component?.type)) && (component.type !== "Select" && component.type !== "FormWizard") && component.type !== "RadioButton" && !borderRadiusRestrictedTypes.includes(component?.type) &&
        <BorderRadius
        label={DEFAULT_BORDER_RADIUS_LABEL}
        defaultValue={borderRadius || DEFAULT_BORDER_RADIUS.selected()}
        isCheckedIn={props.isCheckedIn}
        />
        }
        {
          (!componentTypes.includes(component?.type) && !FontFamilyRestrictedTypes.includes(component?.type)) ?
        isCoreV3 ? <FontFamilyV3
          label={DEFAULT_FONT_FAMILY_LABEL}
          defaultValue={fontFamily}
          isCheckedIn={props.isCheckedIn}
        /> : <FontFamily
        label={DEFAULT_FONT_FAMILY_LABEL}
        defaultValue={fontFamily}
        isCheckedIn={props.isCheckedIn}
      /> : ""
      }
      {
        (!componentTypes.includes(component?.type)) && component.type !== "VideoKYC" && component?.type !== "FormWizard" && component.type !== "RadioButton" &&
        <FontSize
          label={DEFAULT_FONT_SIZE_LABEL}
          defaultValue={fontSize}
          isCheckedIn={props.isCheckedIn}
        />
      }
        {
          component?.type === "Text" &&
          <LineHeight
            label={DEFAULT_LINE_HEIGHT_LABEL}
            defaultValue={lineHeight}
            isCheckedIn={props.isCheckedIn}
          />
        }
        {
          (component.type !== "Select" && component.type !== "FormWizard" && !componentTypes.includes(component?.type) && !FontWeightRestrictedTypes.includes(component?.type)) && component.type !== "RadioButton" &&
          <>
          { !componentTypeForSnack &&  
        <FontWeight
          label={DEFAULT_FONT_WEIGHT}
          defaultValue={fontWeight}
          isCheckedIn={props.isCheckedIn}
        />
        }
        </>
        }
        {
          (component.type !== "Select" && component.type !== "FormWizard" && !componentTypes.includes(component?.type)) && component.type !== "RadioButton" && component.type !== "Table" && !shouldHidePropsForCustomSnack &&
        <BackgroundColor
          label={DEFAULT_BACKGROUND_COLOR}
          defaultValue={backgroundColor || DEFAULT_BACKGROUNDCOLOR.selected()}
          isCheckedIn={props.isCheckedIn}
        />
        }
        {(component.type === "Container" || component.type === "Row" || component.type === "Column" || component.type === "Grid") &&
          <ApplyBackgroundImage
            open={() => {
              dispatch(onSetBgdMenuVisibility(true));
            }}
            label={"Background Image"}
            menuVisibility={backgroundMenuVisibility}
          />
        }
        {backgroundMenuVisibility ?
          (
            <BackgroundImageMenu
              type={component.type}
              from="Layout"
              where="$deviceType.backgroundImage"
              close={() => dispatch(onSetBgdMenuVisibility(false))}
              isCheckedIn={props.isCheckedIn}
            />
          ) : null
        }
        {
          (component.type !== "VideoKYC" && component.type !== "Table" && component.type !== "FormWizard" && component.type !== "Select" && !componentTypes.includes(component?.type) && !ColorRestrictedTypes.includes(component?.type)) && !componentTypeForSnack && component.type !== "RadioButton" &&
        <Color
          label={DEFAULT_COLOR}
          defaultValue={color}
          isCheckedIn={props.isCheckedIn}
        />
        }
        {
          (component.type !== "Select" && component.type !== "FormWizard" && !componentTypes.includes(component?.type)) && component.type !== "RadioButton" && !borderColorRestrictedTypes.includes(component?.type) &&!shouldHidePropsForCustomSnack &&
        <BorderColor
          label={DEFAULT_BORDER_COLOR}
          defaultValue={borderColor}
          isCheckedIn={props.isCheckedIn}
        />
        }
        {
        dateRangeColorType.includes(component?.type) &&
        <DateRangeColor
          label={DEFAULT_DATE_RANGE_COLOR}
          defaultValue={dateRangeColor}
          isCheckedIn={props.isCheckedIn}
        />
        }
        {component.type !== "FormWizard" && 
          <ZIndex
            label={DEFAULT_ZINDEX_LABEL}
            defaultValue={zIndex}
            isCheckedIn={props.isCheckedIn}
          />
        }
        {component.type === "FormWizard" && deviceType !== 'Sm' &&
          <div style={{ borderTop: '1px solid #A8ABBB40', paddingTop: '2px', marginTop: '10px' }}>
            <p style={{
              fontSize: "11px",
              fontWeight: 700,
              color: '#282B31',
              margin: '12px 0px 10px 0px'
            }}>Side bar</p>
            <WizardWidth
              label={DEFAULT_WIDTH}
              defaultValue={wizardWidth}
              isCheckedIn={props.isCheckedIn}
            />
          </div>
        }
        <Panel section="layout" isCheckedIn={props.isCheckedIn}/>
      </form >
    </>
  );
};
